const ClosingParagraphs = ({ paragraphs = [] }) => (
  <div className="pdf-mb-40">
    {paragraphs.map((paragraph, idx) => (
      <p
        key={idx}
        className="pdf-pre-line"
        dangerouslySetInnerHTML={{ __html: paragraph }}
      />
    ))}
  </div>
)

export default ClosingParagraphs
